import { createSlice, createSelector } from "@reduxjs/toolkit";
import { createSetQueryParamsReducer } from "./common";
import { StandardObject } from "utils";

interface ApplicationFormState {
  queryParams: StandardObject;
  quickFilter: StandardObject;
}

const initialState: ApplicationFormState = {
  queryParams: {},
  quickFilter: {},
};

export const applicationFormSlice = createSlice({
  name: "applicationForm",
  initialState,
  reducers: {
    setQueryParams: createSetQueryParamsReducer("queryParams"),
    setQuickFilter: createSetQueryParamsReducer("quickFilter"),
  },
});

const selectApplicationForm = (state: {
  applicationForm: ApplicationFormState;
}) => state.applicationForm;

export const selectApplicationFormState = createSelector(
  [selectApplicationForm],
  (s: ApplicationFormState) => {
    return {
      queryParams: s.queryParams,
      quickFilter: s.quickFilter,
      combinedQuery: { ...s.queryParams, ...s.quickFilter },
    };
  }
);

export const { setQueryParams, setQuickFilter } = applicationFormSlice.actions;

export default applicationFormSlice.reducer;
